export default function initNewsCategoriesComponent() {
    const listElements = document.querySelectorAll(".news-list-categories button");
    let revertElementsToHidden = [];

    if (listElements.length > 0) {
        for (let x = 0; x < listElements.length; x++) {
            let listElement = listElements[x];

            listElement.onclick = function (e) {
                listElements.forEach((el, index) => {
                    if (index !== x) {
                        el.classList.remove("is-white");
                    }
                });
                listElement.classList.add("is-white");
                filterNews(listElement);
            }
        }
    }

    function filterNews(element) {
        let sCategory = element.getAttribute('data-category-id');

        for (let x = 0; x < revertElementsToHidden.length; x++) {
            revertElementsToHidden[x].classList.add("additional-card");
        }

        if (sCategory === 'all') {
            showAll();
        } else {
            doFilter(sCategory);
        }
    }

    function showAll() {
        let news = document.querySelectorAll(".news");
        for (let x = 0; x < news.length; x++) {
            news[x].classList.remove('hidden-card');
        }
        revertElementsToHidden = [];
    }

    function doFilter(activeCategory) {
        let news = document.querySelectorAll(".news");
        for (let x = 0; x < news.length; x++) {
            let sCategories = news[x].getAttribute("data-categories");
            let aCategories = sCategories.split(",");
            if (canDisplay(activeCategory, aCategories)) {
                news[x].classList.remove('hidden-card');

                if (news[x].classList.contains('additional-card')) {
                    news[x].classList.remove('additional-card');
                    revertElementsToHidden.push(news[x]);
                }
            } else {
                news[x].classList.add('hidden-card');
            }
        }
    }

    function canDisplay(activeCategory, availableCategories) {
        for (let x = 0; x < availableCategories.length; x++) {
            if (availableCategories[x] === activeCategory) {
                return true;
            }
        }
        return false;
    }
}
